(() => {
  const PRICE_OPTIONS = [
    { value: 'price-ascending', label: 'Price: Low to High' },
    { value: 'price-descending', label: 'Price: High to Low' }
  ];

  const isSearchPage = () => Boolean(document.querySelector('.template-search'));

  function enhanceMobileSort() {
    if (!isSearchPage()) return;

    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      const existing = new Set(Array.from(select.options).map((option) => option.value));
      PRICE_OPTIONS.forEach(({ value, label }) => {
        if (!existing.has(value)) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          select.appendChild(option);
        }
      });

      const currentSort = new URL(window.location.href).searchParams.get('sort_by');
      if (PRICE_OPTIONS.some((option) => option.value === currentSort)) {
        select.value = currentSort;
      }
    });
  }

  function enableNumberedPagination() {
    if (!isSearchPage()) return;

    document.querySelectorAll('.template-search .pagination-wrapper').forEach((wrapper) => {
      const nav = wrapper.querySelector('nav.pagination');
      const infinite = wrapper.querySelector('infinite-scrolling');

      if (nav) nav.classList.remove('hidden');
      if (infinite) infinite.style.display = 'none';

      wrapper.classList.remove('infinite');
      wrapper.classList.add('pagination');
    });
  }

  function enhance() {
    enhanceMobileSort();
    enableNumberedPagination();
  }

  function init() {
    enhance();

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        enhance();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
